import {
  endpointPortfolioCompanyGET,
  PortfolioCompanyResponse,
} from '~/api/def/endpoints/portfolioCompanyEndpoint';
import { BaseSearchProps, ExtendedDocCompareChunkFinderChunk } from '../types';

const convertPortfolioToSearchResult = (
  portfolio: PortfolioCompanyResponse,
): ExtendedDocCompareChunkFinderChunk => {
  const documentId =
    portfolio.id && portfolio.fundId
      ? `${portfolio.id}:${portfolio.fundId}`
      : portfolio.id || '';

  const displayText = [
    `Name: ${portfolio.name || 'N/A'}`,
    `Fund: ${portfolio.fundName || 'N/A'}`,
    `Sector: ${portfolio.sectorName || 'N/A'}`,
    `Status: ${portfolio.companyStatus || 'N/A'}`,
    `Round: ${portfolio.currentRound || 'N/A'}`,
  ].join(' | ');

  return {
    id: portfolio.id || '',
    document_id: documentId,
    document_name: portfolio.name || '',
    client_id: '',
    text: displayText,
    type: 'Portfolios',
    bbox_page_start: 0,
    bbox_page_end: 0,
    bbox_x1: 0,
    bbox_y1: 0,
    bbox_x2: 0,
    bbox_y2: 0,
    _originalPortfolio: portfolio,
  };
};

export const searchPortfolios = async ({
  searchTerm,
  onSuccess,
  onError,
  onEmpty,
}: BaseSearchProps<ExtendedDocCompareChunkFinderChunk>): Promise<void> => {
  try {
    const response = await endpointPortfolioCompanyGET();

    if (!response || !Array.isArray(response)) {
      onEmpty?.();
      return;
    }

    const portfolios = response;
    const searchLower = searchTerm.toLowerCase();

    const filteredPortfolios = portfolios.filter(
      (portfolio: PortfolioCompanyResponse) => {
        const nameMatch = portfolio.name?.toLowerCase().includes(searchLower);
        const shortNameMatch = portfolio.shortName
          ?.toLowerCase()
          .includes(searchLower);
        const roundMatch = portfolio.currentRound
          ?.toLowerCase()
          .includes(searchLower);
        const statusMatch = portfolio.companyStatus
          ?.toLowerCase()
          .includes(searchLower);
        const sectorMatch = portfolio.sectorName
          ?.toLowerCase()
          .includes(searchLower);
        const fundMatch = portfolio.fundName
          ?.toLowerCase()
          .includes(searchLower);
        const jurisdictionMatch = portfolio.jurisdiction?.name
          ?.toLowerCase()
          .includes(searchLower);

        return (
          nameMatch ||
          shortNameMatch ||
          roundMatch ||
          statusMatch ||
          sectorMatch ||
          fundMatch ||
          jurisdictionMatch
        );
      },
    );

    const searchResults = filteredPortfolios.map(
      convertPortfolioToSearchResult,
    );

    if (searchResults.length === 0) {
      onEmpty?.();
    } else {
      onSuccess?.(searchResults);
    }
  } catch (error) {
    onError?.(error as Error);
  }
};
